<template>
    <div v-if="isLoggedIn && productInfo.allow_reviews" class="review-form pt-0">
        <form name="form-review" id="form-review">
          <div class="row review-form-row">
            <div class="form-group col-md-4">
              <label for="review-stars">Review Stars</label>
              <select name="rating" id="review-stars" class="form-select" v-model="reviewRating">
                  <option value="5">5</option>
                  <option value="4">4</option>
                  <option value="3">3</option>
                  <option value="2">2</option>
                  <option value="1">1</option>
              </select>
            </div>
            <div class="form-group col-md-4">
              <label for="review-author">Your Name <span class="text-danger">*</span></label>
              <input type="text" name="name" class="form-control" id="review-author" v-model="user_name"
                  placeholder="Your Name" readonly="" />
            </div>
            <div class="form-group col-md-4">
              <label for="review-email">Email Address <span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="review-email" placeholder="Email Address"
                  v-model="email" readonly="" />
            </div>
            <div class="form-group col-12">
                <label for="review-text">Your Review</label>
                <textarea name="text" class="form-control" id="review-text" v-model="reviewText"
                rows="6"></textarea>
                <span class="text-danger" v-if="errorReview">
                {{ errorText }}</span>
            </div>
            <div class="form-group text-align-center col-12 d-flex flex-nowrap gap-10 align-items-start">
                <button id="button-review" type="button" @click="storeReviews"
                class="button button-fill-black button-medium flex-shrink-0">Submit</button>
                <p id="message" class="mb-0 flex-grow-1">Your email address will not be published. Required fields are marked *</p>
            </div>
          </div>
        </form>
    </div>
    <div v-else-if="!isLoggedIn">
        <a href="/login">Login</a> to submit a review.
    </div>
</template>
<script setup>
import { ref, computed, getCurrentInstance } from 'vue';
import { useGetters } from '@/composables';
import axios from 'axios';

const { isLoggedIn } = useGetters();
const instance = getCurrentInstance();
const emitter = instance.appContext.config.globalProperties.emitter;
const props = defineProps({
    productInfo: {
        type: Object,
        required: true
    },
    slug: {
        type: String,
        required: true
    }
});
const reviewText = ref("");
const errorReview = ref(false);
const errorText = ref("");
const reviewRating = ref(5);

const user_name = computed(() => {
  let userDetails = JSON.parse(localStorage.getItem("loggedinUser"));
  if (userDetails) {
    return userDetails.name;
  } else {
    return "";
  }
});

const email = computed(() => {
  let userDetails = JSON.parse(localStorage.getItem("loggedinUser"));
  if (userDetails) {
    return userDetails.email;
  } else {
    return "";
  }
});

const storeReviews = () => {
  if (reviewText.value.length < 25) {
    errorReview.value = true;
    errorText.value = "Please enter minimum 25 characters";
    return false;
  }
  emitter.emit("showLoader");
  axios
    .post(
      `${process.env.VUE_APP_API_BASE}auth/rateProduct`,
      {
        rating: reviewRating.value,
        slug: props.slug,
        comments: reviewText.value,
      },
      {
        headers: {
          "Content-type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
    .then((response) => {
      let level = "";
      if (response.data.error) {
        level = "danger";
      } else {
        level = "success";
        errorReview.value = false;
        errorText.value = "";
        reviewText.value = "";
      }
      emitter.emit('showFlashAlertMessage', {message: response.data.message, level: level});
    }) 
    .finally(() => {
      emitter.emit("hideLoader");
    });
};
</script>
<style scoped>
.review-form .review-form-row {
  row-gap: var(--gap-10);
  --bs-gutter-x: var(--gap-10);
}
.review-form #message{
  color: var(--body-color);
  font-size: var(--font-size-14);
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  background: var(--info-bg-subtle);
  padding: var(--padding-5) var(--padding-10);
}
.review-form form .form-group label{
    margin-bottom: 3px;
    font-size: var(--font-size-14);
}
.review-form form .form-group .form-control{
  background: #fff;
  border-width: 1px;
}
.review-form form .form-group textarea.form-control{
    resize: none;
}
@media (min-width: 1200px) {
  .review-form .review-form-row {
    --bs-gutter-x: var(--gap-10);
  }
}
</style>